module.exports = __webpack_public_path__ + "img/antes_despues_238.323f4b28.png";